module.exports = __webpack_public_path__ + "img/gambling_commission.1c92922a.png";